import getAllColumnsSettings from './all-columns-settings';
import getThisColumnSettings from './this-column-settings';

export default {
  getAllColumnsSettings,
  getThisColumnSettings,
};
